export default __webpack_public_path__ + "static/fisheye-e4db31dea9f16c393a557ddb23fe4354.png";